// Icon name resolution for the static-SVG Phosphor catalog.
//
// Static SVGs are named by Phosphor's canonical PascalCase name (e.g.
// "ShoppingBag.svg"). Older widget configs stored Lucide-style aliases from the
// previous curated map (e.g. "Mail", "DeliveryTruck"); ALIASES normalizes those
// to the canonical Phosphor name so existing stored configs keep rendering.

/** Legacy alias → canonical Phosphor name. */
export const ALIASES: Record<string, string> = {
  DeliveryTruck: "Truck",
  CheckSquare: "Check",
  Award: "Medal",
  Gem: "Diamond",
  Zap: "Lightning",
  Mail: "Envelope",
  Sparkles: "Sparkle",
  Flame: "Fire",
  Music: "MusicNote",
  Settings: "Gear",
  Search: "MagnifyingGlass",
  Unlock: "LockOpen",
  Send: "PaperPlaneTilt",
  Download: "DownloadSimple",
  Upload: "UploadSimple",
  Volume2: "SpeakerHigh",
  Wifi: "WifiHigh",
  Server: "HardDrive",
  AlertCircle: "WarningCircle",
  HelpCircle: "Question",
  ChevronRight: "CaretRight",
  ChevronDown: "CaretDown",
  ChevronUp: "CaretUp",
  ChevronLeft: "CaretLeft",
  ExternalLink: "ArrowSquareOut",
  Redo: "ArrowClockwise",
  Undo: "ArrowCounterClockwise",
  Pin: "PushPin",
  MessageCircle: "ChatCircle",
  Share2: "ShareNetwork",
  Layers: "Stack",
  Grid: "GridFour",
  Layout: "SquaresFour",
  Smartphone: "DeviceMobile",
  Tablet: "DeviceTablet",
  Map: "MapTrifold",
  Navigation: "NavigationArrow",
  Home: "House",
  Building: "Buildings",
  Store: "Storefront",
  BarChart: "ChartBar",
  PieChart: "ChartPie",
  TrendingUp: "TrendUp",
  Activity: "Waveform",
  Film: "FilmStrip",
  RefreshCw: "ArrowsCounterClockwise",
  ArrowUpRight: "ArrowUpRight",
};

/**
 * Normalize a stored icon name to its canonical Phosphor name. Returns null for
 * empty input. Unknown names pass through unchanged (assumed already canonical);
 * a missing SVG file just renders nothing, so this never throws.
 */
export function resolveIconName(name: string | null | undefined): string | null {
  if (!name) return null;
  const trimmed = name.trim();
  if (!trimmed) return null;
  return ALIASES[trimmed] ?? trimmed;
}
